import useDistinctActions from './useDistinctActions';
import useRecordScope from './useRecordScope';
import { buildFilterTerms } from './audit-log-filters';
import { deriveQueryStatus } from './query-status';

export default function useAuditLogActionOptions({ recordRef, filters }) {
  const scope = useRecordScope({ recordRef, filters });
  const where = { _and: [scope.where, ...buildFilterTerms(filters)] };
  const distinct = useDistinctActions({ where, skip: Boolean(scope.loading || scope.error) });

  const loading = Boolean(scope.loading || distinct.loading);
  const error = scope.error ?? distinct.error;

  return {
    ...distinct,
    loading,
    error,
    status: deriveQueryStatus({ loading, error, isEmpty: distinct.actions.length === 0 }),
  };
}
